import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const HotelSearchHeaderSkeleton = ({ isMobile = false }) => {
  return (
    <Grid container direction="column" rowSpacing={{ xs: 1, sm: 2 }}>
      {/* Resultados */}
      <Grid item sx={{ mb: { xs: 1, sm: 0 } }}>
        <Skeleton variant="text" width={isMobile ? '80%' : '40%'} height={20} />
      </Grid>

      {/* Barra de progreso */}
      <Grid item sx={{ width: '100%', mb: { xs: 1, sm: 2 } }}>
        <Skeleton variant="rectangular" height={15} />
      </Grid>

      {/* Filtros */}
      <Grid
        container
        columnSpacing={2}
        rowSpacing={{ xs: 2 }}
        alignItems="center"
      >
        {/* Input */}
        <Grid
          item
          xs={12}
          sm={10}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height={55}
            sx={{ borderRadius: '8px' }}
          />
        </Grid>

        {/* Botón */}
        <Grid
          item
          xs={12}
          sm={2}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height={55}
            sx={{ borderRadius: '8px' }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HotelSearchHeaderSkeleton;
